import { Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';
import { GetPreferredResult, GetResult, TextZoom } from '@capacitor/text-zoom';

@Injectable({
    providedIn: 'root',
})
export class TextZoomService {
    constructor() {}

    public get(): Observable<GetResult> {
        return from(TextZoom.get());
    }

    public set(value: number): Observable<void> {
        return from(TextZoom.set({ value }));
    }

    public getPreferred(): Observable<GetPreferredResult> {
        return from(TextZoom.getPreferred());
    }
}
